import GetCustomFieldsRequestModelBase from '../_generated/modelBases/get-custom-fields-request-model-base';

export default class GetCustomFieldsRequestModel extends GetCustomFieldsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
